import dayjs from 'dayjs';

export const DATE_FORMATS = {
  DAY_MONTH_YEAR: 'DD-MMM-YYYY',
  DAY_MONTH_YEAR_WITH_DAY: 'ddd, DD-MMM-YYYY',
  DATE_WITH_DATETIME: 'MMM D, YYYY, h:mm A',
} as const;

export function formatDate(value: string | null | undefined, format: string, nullishValue = ''): string {
  return value ? dayjs(value).format(format) : nullishValue;
}
